import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BankInfoData } from 'src/app/application/bank-info/bank-info.data';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-bank-info-token',
    templateUrl: './bank-info-token.component.html',
    styleUrls: ['./bank-info-token.component.css']
})
export class BankInfoTokenComponent implements OnInit {
    production: boolean = environment.production;

    token: any;

    bankInfo: BankInfoData = new BankInfoData(this.formBuilder);
    states: any[] = [];
    bankTypes: any[] = [];

    submitted = false;

    private applicationId: number;

    constructor(
        private connectionService: ConnectionService,
        public router: Router,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute
    ) {
        this.route.params.subscribe((params: any) => {
            if (params.id) {
                this.applicationId = params.id;
            } else {
                this.router.navigateByUrl('/');
            }
        });
    }

    ngOnInit() {
        this.token = this.route.snapshot.queryParams.token;
        this.getStates().then(
            (statesData: any) => {
                this.getBankTypes();
            }
        );
    }

    get form() { return this.bankInfo.form.controls; }

    getStates() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestUnsecured(environment.gateway + 'utils/states', 'application/json').subscribe(
                (data: any) => {
                    this.states = data.object;
                    resolve(data);
                },
                (error: any) => {
                    resolve(error);
                }
            );
        });
    }

    getBankTypes() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequest(environment.gateway + 'utils/bankTypes', 'application/json').subscribe(
                (data: any) => {
                    this.bankTypes = data.object;
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    uploadBankInfo() {
        this.submitted = true;

        if (this.bankInfo.form.invalid) {
            return;
        }

        return new Promise((resolve, reject) => {
            this.connectionService.postCustomRequest(
                environment.gateway + 'applicationNl/bankinfo/' + this.applicationId,
                this.getBankinfoData(), 'application/json', null, 'token', this.token).subscribe(
                    (data: any) => {
                        this.router.navigateByUrl('/contract-token', { state: { applicationId: this.applicationId, token: this.token } });
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

    getBankinfoData() {
        return this.bankInfo.encode();
    }

    onCompleteInformationClick() {
        this.bankInfo.decode(
            {
                accountName: 'Audio visual equipment',
                accountNumber: '1222613232',
                accountNumberConfirm: '1222613232',
                accountRoutingNumber: '121000358',
                accountType: 'CHECKING',
                bankName: 'US Bank association',
                city: 'Bremen',
                state: 'AL'
            }
        );
    }
}
